import React, { useState } from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, CalendarIcon, MessageCircleIcon, InstagramIcon, FacebookIcon, LinkedinIcon, ChevronRightIcon, SendIcon } from 'lucide-react';
import emailjs from '@emailjs/browser';
const CALENDAR_URL = 'https://calendar.app.google/gDsqAVqmwUYmaZHe9';
const WHATSAPP_URL = 'https://wa.me/14028720639';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/ogJMkN5dd1hJJJtdpvFFQv/IMG_6635.jpg';
const EMAILJS_SERVICE_ID = 'service_doctorecommerce';
const EMAILJS_TEMPLATE_ID = 'template_legal_lead';
const EMAILJS_PUBLIC_KEY = 'YOUR_PUBLIC_KEY';
export function Footer() {
  const [footerForm, setFooterForm] = useState({
    name: '',
    email: '',
    phone: '',
    company: ''
  });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const handleFooterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSending(true);
    try {
      await emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, {
        user_name: footerForm.name,
        user_email: footerForm.email,
        user_phone: footerForm.phone,
        company_name: footerForm.company,
        source: 'Footer Quick Form'
      }, EMAILJS_PUBLIC_KEY);
      setSent(true);
      setFooterForm({
        name: '',
        email: '',
        phone: '',
        company: ''
      });
      setTimeout(() => setSent(false), 4000);
    } catch {
      alert('Error al enviar. Llámanos al (402) 872-0639.');
    } finally {
      setSending(false);
    }
  };
  const servicios = ['Meta Ads · Google Ads · TikTok Ads · YouTube Ads', 'Email · SMS · Retargeting Automatizado', 'Automatización con IA para Ventas 24/7', 'Funnels Quirúrgicos por Industria', 'Blindaje Digital & Anti-Ban', 'PR Digital & Posicionamiento en Medios', 'CRM & Data Tracking Avanzado', 'Video Marketing IA · SEO · Branding', 'Gestión de Reputación · Google Maps', 'Diseño Web · Landing Pages · CRO'];
  const recursos = [{
    label: 'Blog de Estrategia',
    href: '#'
  }, {
    label: 'Casos de Éxito',
    href: '#'
  }, {
    label: 'Política de Privacidad',
    href: '#'
  }, {
    label: 'Términos y Condiciones',
    href: '#'
  }];
  return <footer className="bg-[#0d0d0d] border-t border-white/5" data-id="element-103">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-12" data-id="element-104">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8" data-id="element-105">
          {/* Column 1 — Brand */}
          <div className="space-y-6" data-id="element-106">
            <img src={LOGO_URL} alt="Doctor Ecommerce" className="h-14 w-auto object-contain" data-id="element-107" />
            <p className="font-heading text-gold italic text-lg leading-snug" data-id="element-108">
              La cura para negocios estancados.
            </p>
            <p className="font-body text-gray-400 text-sm leading-relaxed" data-id="element-109">
              En Doctor Ecommerce no gestionamos redes, operamos sistemas de
              adquisición de alto rendimiento. Con sede estratégica en Tampa,
              Florida, servimos a dueños de negocios en todo Estados Unidos,
              transformando presupuestos publicitarios en máquinas de generación
              de llamadas y ventas diarias.
            </p>
            {/* Social Icons */}
            <div className="flex items-center gap-4 pt-2" data-id="element-110">
              <a href="#" aria-label="Instagram" className="text-gray-500 hover:text-gold transition-colors" data-id="element-111">
                <InstagramIcon className="w-6 h-6" data-id="element-112" />
              </a>
              <a href="#" aria-label="Facebook" className="text-gray-500 hover:text-gold transition-colors" data-id="element-113">
                <FacebookIcon className="w-6 h-6" data-id="element-114" />
              </a>
              <a href="#" aria-label="LinkedIn" className="text-gray-500 hover:text-gold transition-colors" data-id="element-115">
                <LinkedinIcon className="w-6 h-6" data-id="element-116" />
              </a>
              <a href="#" aria-label="TikTok" className="text-gray-500 hover:text-gold transition-colors" data-id="element-117">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-118">
                  <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.34-6.34V8.73a8.19 8.19 0 004.76 1.52V6.8a4.84 4.84 0 01-1-.11z" data-id="element-119" />
                </svg>
              </a>
            </div>
          </div>

          {/* Column 2 — Servicios */}
          <div data-id="element-120">
            <h3 className="font-heading text-gold text-sm font-bold uppercase tracking-widest mb-6" data-id="element-121">
              Servicios
            </h3>
            <ul className="space-y-3" data-id="element-122">
              {servicios.map((servicio, i) => <li key={i} className="font-body text-gray-400 text-sm leading-relaxed" data-id="element-123">
                  {servicio}
                </li>)}
            </ul>
          </div>

          {/* Column 3 — Recursos */}
          <div data-id="element-124">
            <h3 className="font-heading text-gold text-sm font-bold uppercase tracking-widest mb-6" data-id="element-125">
              Recursos
            </h3>
            <ul className="space-y-3" data-id="element-126">
              {recursos.map((recurso, i) => <li key={i} data-id="element-127">
                  <a href={recurso.href} className="flex items-center gap-2 font-body text-gray-400 text-sm hover:text-white transition-colors" data-id="element-128">
                    <ChevronRightIcon className="w-4 h-4 text-gray-600" data-id="element-129" />
                    {recurso.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Column 4 — Contacto Directo */}
          <div data-id="element-130">
            <h3 className="font-heading text-gold text-sm font-bold uppercase tracking-widest mb-6" data-id="element-131">
              Contacto Directo
            </h3>
            <ul className="space-y-4 mb-8" data-id="element-132">
              <li className="flex items-start gap-3" data-id="element-133">
                <MapPinIcon className="w-5 h-5 text-gray-500 shrink-0 mt-0.5" data-id="element-134" />
                <span className="font-body text-gray-400 text-sm" data-id="element-135">
                  1001 WATER ST, TAMPA FL 33602
                </span>
              </li>
              <li data-id="element-136">
                <a href="tel:4028720639" className="flex items-center gap-3 text-gray-400 hover:text-gold transition-colors" data-id="element-137">
                  <PhoneIcon className="w-5 h-5 text-gray-500" data-id="element-138" />
                  <span className="font-body text-sm" data-id="element-139">(402) 872-0639</span>
                </a>
              </li>
              <li data-id="element-140">
                <a href="mailto:doctor.ecommerceus@gmail.com" className="flex items-center gap-3 text-gray-400 hover:text-gold transition-colors" data-id="element-141">
                  <MailIcon className="w-5 h-5 text-gray-500" data-id="element-142" />
                  <span className="font-body text-sm" data-id="element-143">
                    doctor.ecommerceus@gmail.com
                  </span>
                </a>
              </li>
            </ul>

            {/* CTA Buttons */}
            <div className="space-y-3" data-id="element-144">
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 w-full py-3 px-4 bg-emerald hover:bg-emerald-light text-white font-bold text-sm rounded-lg transition-colors" data-id="element-145">
                <MessageCircleIcon className="w-5 h-5" data-id="element-146" />
                Habla con un Especialista
              </a>
              <a href={CALENDAR_URL} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 w-full py-3 px-4 border-2 border-gold text-gold hover:bg-gold hover:text-carbon font-bold text-sm rounded-lg transition-colors" data-id="element-147">
                <CalendarIcon className="w-5 h-5" data-id="element-148" />
                RESERVAR DIAGNÓSTICO
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="border-t border-white/5" data-id="element-149">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-id="element-150">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start" data-id="element-151">
            {/* Partners */}
            <div data-id="element-152">
              <p className="font-heading text-xs font-bold uppercase tracking-widest text-gray-500 mb-4" data-id="element-153">
                Partners Certificados y Tecnología de Élite
              </p>
              <div className="flex flex-wrap items-center gap-4" data-id="element-154">
                {['Meta Business Partner', 'Google Ads', 'HubSpot', 'Shopify Experts'].map((partner, i) => <div key={i} className="bg-[#1a1a1a] border border-white/5 rounded-lg px-4 py-2 text-xs font-body text-gray-500 font-medium" data-id="element-155">
                    {partner}
                  </div>)}
              </div>
            </div>

            {/* Quick Contact Form */}
            <div data-id="element-156">
              <p className="font-heading text-xs font-bold uppercase tracking-widest text-gray-500 mb-4" data-id="element-157">
                ¿Quieres que te contactemos?
              </p>
              <form onSubmit={handleFooterSubmit} className="flex flex-col sm:flex-row flex-wrap gap-3" data-id="element-158">
                <input type="text" placeholder="Tu Nombre" required value={footerForm.name} onChange={e => setFooterForm(p => ({
                ...p,
                name: e.target.value
              }))} className="flex-1 min-w-[140px] bg-[#1a1a1a] border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-gold transition-colors" data-id="element-159" />
                <input type="email" placeholder="Tu Email" required value={footerForm.email} onChange={e => setFooterForm(p => ({
                ...p,
                email: e.target.value
              }))} className="flex-1 min-w-[140px] bg-[#1a1a1a] border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-gold transition-colors" data-id="element-160" />
                <input type="tel" placeholder="Tu Teléfono" required value={footerForm.phone} onChange={e => setFooterForm(p => ({
                ...p,
                phone: e.target.value
              }))} className="flex-1 min-w-[140px] bg-[#1a1a1a] border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-gold transition-colors" data-id="element-161" />
                <input type="text" placeholder="Nombre de tu Empresa" value={footerForm.company} onChange={e => setFooterForm(p => ({
                ...p,
                company: e.target.value
              }))} className="flex-1 min-w-[140px] bg-[#1a1a1a] border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-gold transition-colors" data-id="element-162" />
                <button type="submit" disabled={sending} className="bg-gold hover:bg-gold-light text-carbon font-bold text-sm px-6 py-2.5 rounded-lg transition-colors disabled:opacity-60 flex items-center gap-2 justify-center" data-id="element-163">
                  {sent ? '✓ ENVIADO' : sending ? 'ENVIANDO...' : 'ENVIAR'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-white/5" data-id="element-164">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-gray-600" data-id="element-165">
          <p data-id="element-166">© 2026 Doctor Ecommerce. Todos los derechos reservados.</p>
          <p data-id="element-167">(402) 872-0639</p>
        </div>
      </div>
    </footer>;
}